import memoizeOne from 'memoize-one';

import type { GetClient, LoomPluginOptions, VideoMeta } from '@atlaskit/editor-plugins/loom';

import type { OpenLoomRecorderParams } from '@confluence/loom-utils';

export type LoomProviderConfig = {
	openLoomRecorder: (params: OpenLoomRecorderParams) => Promise<void>;
};

const createLoomClient = async (loomProviderConfig: LoomProviderConfig): GetClient => {
	const { openLoomRecorder } = loomProviderConfig;
	return {
		status: 'loaded',
		client: {
			attachToButton: ({ button, onInsert }) => {
				button.addEventListener('click', () => {
					void openLoomRecorder({
						onInsert: (_, video: VideoMeta) => {
							onInsert(video);
						},
						// intentionally not localized because Loom RecordSDK does not support i18n
						insertButtonText: 'Insert Loom video',
					});
				});
			},
		},
	};
};

export const getLoomProvider = memoizeOne(
	(loomProviderConfig: LoomProviderConfig): LoomPluginOptions => {
		const loomProvider: LoomPluginOptions = {
			loomProvider: {
				getClient: () => createLoomClient(loomProviderConfig),
			},
		};

		return loomProvider;
	},
);
